
function parseResponseData(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {

  const getUserAlerts = (inputParam, metaData) =>
    api
      .getUserAlerts(inputParam, metaData)
      .then(parseResponseData)
      .catch(() => null);

  const sendUserAlertSeenStatus = (inputParams, metaData) =>
    api
      .sendUserAlertSeenStatus(inputParams, metaData)
      .then(parseResponseData)
      .catch(() => null);
  
  const getDowntime = (inputParam, metaData) => {
    return api
      .getDowntime(inputParam, metaData)
      .then(parseResponseData)
      .catch(() => null);
  }

  return {
    getUserAlerts,
    sendUserAlertSeenStatus,
    getDowntime
  };
}

module.exports = serviceFactory;